import React from 'react';
import { ReviewCountdown } from './MarketProfileShared';

type Props = {
  kind: 'position' | 'grading';
  reviewSubmittedAt: string;
  onBack: () => void;
  onContinue?: () => void;
  continueLabel?: string;
  onReviewComplete?: () => void;
};

const COPY = {
  position: {
    title: 'Данные о должности отправлены на проверку',
    text: 'Администратор проверяет сведения о вашей роли и компенсации. Рекомендуемый срок — до 24 часов. После подтверждения вы сможете продолжить заполнение профиля.',
    icon: 'fa-briefcase',
  },
  grading: {
    title: 'Грейдинг отправлен на проверку',
    text: 'Администратор проверяет ответы о вашей зоне ответственности. Рекомендуемый срок — до 24 часов. После подтверждения данные будут учтены в рыночных ориентирах.',
    icon: 'fa-layer-group',
  },
};

export default function QuestionnairePendingReview({
  kind,
  reviewSubmittedAt,
  onBack,
  onContinue,
  continueLabel,
  onReviewComplete,
}: Props) {
  const copy = COPY[kind];

  return (
    <div className="dcf-mp-form dcf-mp-review-pending">
      <button type="button" className="dcf-btn dcf-btn--ghost dcf-mp-back" onClick={onBack}>
        ← К профилю рынка
      </button>

      <section className="dcf-mp-card dcf-mp-review-pending__card">
        <div className="dcf-mp-review-pending__icon" aria-hidden="true">
          <i className={`fas ${copy.icon}`} />
        </div>
        <h1 className="dcf-mp-review-pending__title">{copy.title}</h1>
        <p className="dcf-mp-review-pending__text">{copy.text}</p>

        <div className="dcf-mp-review-pending__status">
          <span className="dcf-status-pill dcf-mp-pill--review">
            <i className="fas fa-hourglass-half" aria-hidden="true" />
            На проверке
          </span>
        </div>

        <ReviewCountdown
          reviewSubmittedAt={reviewSubmittedAt}
          onComplete={onReviewComplete}
        />

        <p className="dcf-mp-review-pending__hint">
          Пока идёт проверка, вы можете вернуться к обзору профиля
          {kind === 'position' ? ' и при необходимости перейти к грейдингу.' : '.'}
        </p>

        <div className="dcf-mp-form-actions">
          <button type="button" className="dcf-btn dcf-btn--secondary" onClick={onBack}>
            К обзору профиля
          </button>
          {onContinue && continueLabel && (
            <button type="button" className="dcf-btn dcf-btn--primary" onClick={onContinue}>
              {continueLabel}
            </button>
          )}
        </div>
      </section>
    </div>
  );
}
